const generateForm11 = [
  {
    label: "คำร้องขอลาที่ต้องการยกเลิก",
    name: "leave_request_cancel",
    storeLabelAs: "leave_request_cancel_name",
    placeholder: "",
    type: "select",
    typeForm: "select",
    formSize: "small",
    optionName: "leave_approve",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เหตุผลที่ต้องการยกเลิก",
    name: "reason_cancel",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm11;
